import React, {Component} from "react";
import _ from 'i18n';
import AnnualTargetManagementRow from "./AnnualTargetManagementRow";
import {connect} from "react-redux";
import {Input} from "antd";
import {setBudgetReccurenceCoeff} from "../../../../actions/actions/eventStats";
import {Col, Row} from "antd";

const budgetManagementTypes = [
  {legend: _('REGISTRANTS_TOTAL_NUMBER')},
  {legend: _('PRICE_PER_UNIT')},
  {legend: _('TOTAL_BUDGET')},
];

class AnnualTargetManagement extends Component {
  handleInputChange = (value) => {
    if (isNaN(value)) return;
    this.props.setBudgetReccurenceCoeff(value/100);
  }
  render() {
    const { budgetManagement } = this.props; 

    return (
      <div>
        <label> 
          <span>
            {budgetManagement.appType === 'registering' && _("TRAININGS")} 
            {budgetManagement.appType === 'cycle' && _("CYCLES")} 
            {budgetManagement.appType === 'cycle_essential' && _("CYCLES Essentiel")} 
            {budgetManagement.appType === 'all_in' && _("SEASONS")} 
            {budgetManagement.appType === 'premium' && "PREMIUM"}
            {budgetManagement.appType === 'monthly_premium' && "PREMIUM Mensuel"}
            {budgetManagement.appType === 'congres' && _("CONGRESS")}
          </span>
          <span className="ml-1">{budgetManagement.year}</span> :</label>
        <div className={'budget-management-legend'}>
          <div className={'BM-details mb-4'}>
            <div className={'BM-details-title'}>
              <img src="/img/icons/manage-BM/settings_1.svg"
                   className={'BM-details-title-icon'}/>{_("ANNUAL_TARGET")}
            </div>
            <div className={'BM-details-text'}>{_("ANNUAL_TARGET_TEXT")}</div>
          </div>
          {budgetManagementTypes.map(({legend}, index) => (
            <React.Fragment>
              <hr/>
              <AnnualTargetManagementRow legend={legend} appType={budgetManagement.appType}/>
            </React.Fragment>
          ))}
          <hr/>
            {(budgetManagement.appType === 'monthly_premium' && budgetManagement.year > 2023) &&
              <Row className={'budget-management-legend-row'}>
                <Col span={10}>
                  <div className={'budget-management-legend-label'}>
                    <span>{_("RECURRENCE_COEFF")}</span>
                  </div>
                </Col>
                { budgetManagement.followUp.length > 0 ?
                  <Col span={8}>
                    <div className={'budget-management-legend-input'}>
                      <span className={'ml-2'}>{budgetManagement.recurrence_coefficient * 100}%</span>
                    </div>
                  </Col>
                  :
                  <Col span={8}>
                  <div className={'budget-management-legend-input'}>
                    <Input
                      suffix='%'
                      onChange={(event) => this.handleInputChange(event.target.value)}
                    />
                  </div>
                </Col>
                }
              </Row>
            }
            {(budgetManagement.appType === 'monthly_premium' && budgetManagement.year == 2023) &&
              <p className={'BM-coeff'}>{_("NO_RECURRENCE_COEFF_FOR_THIS_YEAR")}</p>
            }
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({budgetManagement: state.budgetManagement,});

const mapDispatchToProps = {
  setBudgetReccurenceCoeff,
};

export default connect(mapStateToProps, mapDispatchToProps)(AnnualTargetManagement);






// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/BudgetManagement/AnnualTargetManagement.js